import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

//多语言包
import i18n from './lang' // internationalization

//引入element,全引入
import ElementUI from 'element-ui';

//element按需引入
// import element from './element/index'

import 'element-ui/lib/theme-chalk/index.css';

//引入iconfont
// import './assets/icon/iconfont.css';
import './assets/icons/iconfont.css';

//excel
// import Blob from './excel/Blob'
// import Export2Excel from './excel/Export2Excel.js'

//引入两个文件
import api from './api/api'
import http from './api/http'
//挂载到VUE实例，以便全局使用
Vue.prototype.api = api;
Vue.prototype.http = http;

// 权限控制：引入权限指令
import permissionDirective from './directives/permission'
// 注册全局指令 v-permission
Vue.directive('permission', permissionDirective);

// 权限控制：引入权限检查工具函数
import { 
  hasPermission, 
  hasAnyPermission, 
  hasAllPermissions, 
  hasRole,
  hasAnyRole,
  hasAllRoles,
  isAdmin,
  getUserPermissionCodes,
  getUserRoleCodes
} from './utils/permission'
// 挂载到 Vue 原型，方便在组件中使用
Vue.prototype.$hasPermission = hasPermission;
Vue.prototype.$hasAnyPermission = hasAnyPermission;
Vue.prototype.$hasAllPermissions = hasAllPermissions;
Vue.prototype.$hasRole = hasRole;
Vue.prototype.$hasAnyRole = hasAnyRole;
Vue.prototype.$hasAllRoles = hasAllRoles;
Vue.prototype.$isAdmin = isAdmin;
Vue.prototype.$getUserPermissionCodes = getUserPermissionCodes;
Vue.prototype.$getUserRoleCodes = getUserRoleCodes;

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

//时间处理js
import moment from 'moment'//导入文件
import 'moment-timezone';
Vue.prototype.$moment = moment

import common from './assets/js/common'
Vue.use(common)

Vue.config.productionTip = false;

// Vue.use(element);
Vue.use(ElementUI);

new Vue({
  router,
  i18n,
  store,
  render: h => h(App)
}).$mount('#app');
